import { render, staticRenderFns } from "./indexBak.vue?vue&type=template&id=1b9818fb&scoped=true&"
import script from "./indexBak.vue?vue&type=script&lang=js&"
export * from "./indexBak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9818fb",
  null
  
)

export default component.exports